import * as React from 'react';
import { useIntl } from 'react-intl';

import { Text } from '@notino/react-styleguide';

import { Flex } from '@components/Flex';
import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetailContext';
import { ellipsisClass } from '@styles/common';

import { IVariantsProps } from '../../../../model';
import ShadesDrawerButton from '../../ShadesDrawer';
import { useVariantTransition } from '../useVariantTransition';

import { ColorPicker } from './ColorPicker';
import { messages } from './messages';
import { Container, VariantsList } from './styled';
import { useShouldShowShadeListButton } from './useShouldShowShadeListButton';

export const VariantsColorPickers: React.FC<IVariantsProps> = ({
  selectedId: _selectedId,
  variants: _variants,
  selectedVariant,
}) => {
  const { showGroups, selectedGroup } = useProductDetailContext().variantGroups;
  const { formatMessage } = useIntl();
  const { handleClick, selectedId } = useVariantTransition(_selectedId);
  const { shouldShowShadeListButton } = useShouldShowShadeListButton();

  const variants =
    showGroups && selectedGroup ? selectedGroup.variants : _variants;

  return (
    <Container
      data-testid="pd-variants-color-picker"
      id="pdVariantsColorPicker"
    >
      {shouldShowShadeListButton && (
        <Flex
          align="center"
          justify="space-between"
          margin="0 0 0.75rem"
          gap="1rem"
        >
          <Text typography="labelRegular400" className={ellipsisClass}>
            {selectedVariant.variantType}
          </Text>
          <ShadesDrawerButton
            selectedId={selectedId}
            variants={variants}
            shadeDrawerTitle={formatMessage(messages.pickShade)}
            onClick={handleClick}
          >
            {formatMessage(messages.shadeList)}
          </ShadesDrawerButton>
        </Flex>
      )}

      <VariantsList>
        {variants.map((item) => (
          <ColorPicker
            item={item}
            isSelected={item.webId === selectedId}
            key={item.webId}
            onClick={handleClick}
          />
        ))}
      </VariantsList>
    </Container>
  );
};
